/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSON, FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSON, } from './FxIdDomainSettingsAdvertisementYandexOptionsRewarded';
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementYandexOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementYandexOptions(value) {
    return true;
}
export function FxIdDomainSettingsAdvertisementYandexOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Rewarded': json['Rewarded'] == null ? undefined : FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSON(json['Rewarded']),
    };
}
export function FxIdDomainSettingsAdvertisementYandexOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementYandexOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementYandexOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Rewarded': FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSON(value['Rewarded']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementYandexOptions.js.map